import { createAppRequest } from '@/services/request';
import type {
  CrmGlobalSearchResponse,
  QueryGlobalSearchParams,
} from './types/global-search';

const request = createAppRequest();
const BASE_PATH = '/bff/zy-crm/global-search';

export async function queryGlobalSearch(params: QueryGlobalSearchParams) {
  const { offsetByType, ...rest } = params;
  return request<CrmGlobalSearchResponse>(BASE_PATH, {
    method: 'GET',
    params: {
      ...rest,
      ...(offsetByType
        ? {
            offsetByType: JSON.stringify(offsetByType),
          }
        : {}),
    },
  });
}
